import { LocalStorageKeys } from '@/app/localStorage/types.ts';

let memoryToken: string | null = null;

export const authStore = {
  setToken(token: string) {
    memoryToken = token;
    localStorage.setItem(LocalStorageKeys.Token, token);
  },

  getToken() {
    return memoryToken ?? localStorage.getItem(LocalStorageKeys.Token);
  },

  clear() {
    memoryToken = null;
    localStorage.removeItem(LocalStorageKeys.Token);
  },
};
